var _ellipse, _path, _path2, _path3, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 136,
    viewBox: "0 0 194 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 174.001,
    cy: 91.0024,
    rx: 5.00245,
    ry: 5.00245,
    transform: "rotate(90 174.001 91.0024)",
    fill: "#00FFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M153.645 50.5713C153.645 48.2601 152.727 46.0436 151.093 44.4093C149.459 42.7751 147.242 41.857 144.931 41.857H129.681L119.231 24.4408C117.605 21.73 114.675 20.0713 111.514 20.0713H82.4908C79.3294 20.0713 76.3999 21.73 74.7734 24.4408L64.3237 41.857H49.0737C46.7625 41.857 44.546 42.7751 42.9117 44.4093C41.2775 46.0436 40.3594 48.2601 40.3594 50.5713V107.214C40.3594 109.525 41.2775 111.742 42.9117 113.376C44.546 115.01 46.7625 115.928 49.0737 115.928H144.931C147.242 115.928 149.459 115.01 151.093 113.376C152.727 111.742 153.645 109.525 153.645 107.214V50.5713Z",
    stroke: "url(#paint0_linear_4391_122959)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0045 96.5935C109.036 96.5935 118.79 86.8401 118.79 74.8082C118.79 62.7763 109.036 53.0225 97.0045 53.0225C84.9726 53.0225 75.2188 62.7763 75.2188 74.8082C75.2188 86.8401 84.9726 96.5935 97.0045 96.5935Z",
    stroke: "url(#paint1_linear_4391_122959)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M173.542 28.0089C173.999 28.1688 173.999 28.8309 173.542 28.9906C166.475 31.4598 164.047 33.8129 161.486 40.6539C161.32 41.0969 160.679 41.097 160.513 40.6541C157.95 33.8157 155.524 31.4626 148.458 28.9911C148.001 28.8312 148.001 28.1691 148.458 28.0094C155.525 25.5402 157.953 23.1871 160.514 16.3461C160.68 15.9031 161.321 15.903 161.487 16.3459C164.05 23.1843 166.476 25.5374 173.542 28.0089Z",
    fill: "url(#paint2_linear_4391_122959)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 11,
    width: 26,
    height: 26,
    rx: 13,
    transform: "rotate(90 36 11)",
    fill: "#F2E9FB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4391_122959",
    x1: 152.358,
    y1: 67.2141,
    x2: -25.4769,
    y2: 137.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4391_122959",
    x1: 118.295,
    y1: 74.4508,
    x2: 47.1361,
    y2: 98.4023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4391_122959",
    x1: 174.682,
    y1: 28.2787,
    x2: 129.302,
    y2: 44.1188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.f538b8ae247fc4e9c10d2269c5993d71.svg";
export { ForwardRef as ReactComponent };